module.exports = __webpack_public_path__ + "static/media/bron1.f58fc7f2.jpg";